module.exports = __webpack_public_path__ + "img/google.8d4289c3.svg";